/**
 * Runtime environment config.
 *
 * In Docker / Railway, env vars are injected at container startup via
 * /env-config.js → window.__ENV__. In local Vite dev, they come from
 * import.meta.env.
 *
 * This helper checks window.__ENV__ first, then falls back to import.meta.env.
 */

interface RuntimeEnv {
  VITE_API_BASE_URL?: string
  VITE_GA_MEASUREMENT_ID?: string
}

const runtimeEnv: RuntimeEnv = (window as unknown as { __ENV__?: RuntimeEnv }).__ENV__ || {}

/**
 * Get an environment variable, checking runtime injection first,
 * then Vite build-time env.
 */
export function getEnv(key: keyof RuntimeEnv): string {
  return runtimeEnv[key] || import.meta.env[key] || ''
}
